export default function AccountSection({ title = 'Default Title', subtitle = null, children, className = null }) {
    return (
        <div className={`account__section ${className !==  null ? className : ''}`}>
            <div className="account-section__head">
                <h4 className="account-section__title">{ title }</h4>
                { title && <p className="account-section__subtitle">{ subtitle }</p> }
            </div>

            <div className="account-section__content">
                { children }
            </div>
        </div>
    )
}